import { Stack, Text } from "@mantine/core";
import type { BillingAddress } from "@project/common";
import type { FC } from "react";
import { FormattedMessage } from "react-intl";

interface AddressDisplayProps {
  billingAddress?: BillingAddress | null;
}

export const AddressDisplay: FC<AddressDisplayProps> = ({ billingAddress }) => {
  if (!billingAddress) {
    return (
      <Text>
        <FormattedMessage
          id="text.noBillingAddress"
          defaultMessage="No billing address provided"
        />
      </Text>
    );
  }

  const {
    name,
    address: {
      line1,
      line2,
      city,
      state,
      country,
      postal_code: postalCode,
    },
    type,
  } = billingAddress;

  return (
    <Stack gap="1px">
      {type === "business" && (
        <Text fs="italic">
          <FormattedMessage id="text.businessAccount" defaultMessage="Business account:" />
        </Text>
      )}
      {type === "personal" && (
        <Text fs="italic">
          <FormattedMessage id="text.personalAccount" defaultMessage="Personal account:" />
        </Text>
      )}
      <Text fs="italic">{name}</Text>
      <Text fs="italic">{line1}</Text>
      {line2 && (
        <Text fs="italic">{line2}</Text>
      )}
      <Text fs="italic">
        {postalCode}
        {" "}
        {city}
        {" "}
      </Text>
      <Text fs="italic">
        {country}
        {" "}
        {state}
      </Text>
      {billingAddress.type === "business" && (
        <Text fs="italic">
          {billingAddress.taxId}
          {" "}
          (VAT/GST)
        </Text>
      )}

    </Stack>
  );
};
